(function () {
      const items = document.querySelectorAll('.accordion-item');

      /**
       * Close a single accordion item (animate max-height → 0)
       */
      function closeItem(item) {
        const content = item.querySelector('.accordion-content');
        const header = item.querySelector('.accordion-header');

        // Set explicit px value first so the transition has a "from" value
        content.style.maxHeight = content.scrollHeight + 'px';

        // Force a reflow so the browser registers the starting value
        void content.offsetHeight;

        // Now animate to 0
        content.style.maxHeight = '0px';

        item.classList.remove('active');
        header.setAttribute('aria-expanded', 'false');
      }

      /**
       * Open a single accordion item (animate max-height → scrollHeight)
       */
      function openItem(item) {
        const content = item.querySelector('.accordion-content');
        const header = item.querySelector('.accordion-header');

        item.classList.add('active');
        header.setAttribute('aria-expanded', 'true');

        // Animate to exact height, then set to "auto" after transition for
        // dynamic-content resilience (e.g. images loading)
        content.style.maxHeight = content.scrollHeight + 'px';

        content.addEventListener('transitionend', function onEnd(e) {
          if (e.propertyName !== 'max-height') return;
          // Only set auto if this item is still active
          if (item.classList.contains('active')) {
            //content.style.maxHeight = 'none';
          }
          content.removeEventListener('transitionend', onEnd);
        });
      }

      items.forEach(function (item) {
        const header = item.querySelector('.accordion-header');

        header.addEventListener('click', function () {
          const isActive = item.classList.contains('active');

          // Close every other item
          items.forEach(function (otherItem) {
            if (otherItem !== item && otherItem.classList.contains('active')) {
              closeItem(otherItem);
            }
          });

          // Toggle the clicked item
          if (isActive) {
            closeItem(item);
          } else {
            openItem(item);
          }
        });
      });

      // ── Keyboard: Enter / Space already fire click on <button> ──
      // ── Arrow-key navigation across items ──
      items.forEach(function (item, index) {
        item.querySelector('.accordion-header').addEventListener('keydown', function (e) {
          let target = null;
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            target = items[index + 1];
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            target = items[index - 1];
          } else if (e.key === 'Home') {
            e.preventDefault();
            target = items[0];
          } else if (e.key === 'End') {
            e.preventDefault();
            target = items[items.length - 1];
          }
          if (target) target.querySelector('.accordion-header').focus();
        });
      });
    })();